export default __webpack_public_path__ + "static/media/italy.64c47f12.webp";